module.exports = __webpack_public_path__ + "media/images/league-3-04c068295cdb9297246e8d9c701d0b16.png";